import { Controller } from "@hotwired/stimulus";
import { publishHandler } from "./publishing";
import { executeCommandWithJobCompletion } from "../jobCompletion";
import { translate } from "../translate";
import * as TranslationsKeys from "../locale/translationsKeys";
import { dialogConfirmationButtonClassName, dialogCancelButtonClassName } from "../dialogConstants";
import { trackEvent } from "../../Features/Analytics";
import * as Turbo from "@hotwired/turbo";

export default class ValidationCheckController extends Controller {
    static targets = [
        "publishButton",
        "forcePublishCheckbox"
    ];
    static values = {
        getJobUrl: String,
        isExternalUser: Boolean,
        destinationName: String,
        language: String,
        destinationUniqueId: String,
        publishUrl: String,
        publishPreviewUrl: String,
        activationCode: String,
        requestPublishUrl: String,
        isDestinationCloned: Boolean
    };

    readonly publishButtonTarget!: HTMLButtonElement;
    readonly forcePublishCheckboxTarget!: HTMLInputElement;

    readonly getJobUrlValue!: string;
    readonly isExternalUserValue!: boolean;
    readonly destinationNameValue!: string;
    readonly languageValue!: string;
    readonly destinationUniqueIdValue!: string;
    readonly publishUrlValue!: string;
    readonly publishPreviewUrlValue!: string;
    readonly activationCodeValue!: string;
    readonly requestPublishUrlValue!: string;
    readonly isDestinationClonedValue!: boolean;

    connect() {
    }

    async publish() {
        await this.publishCommon(false, !this.isDestinationClonedValue, false);
    };

    async publishClone() {
        await this.publishCommon(false, false, true);
    };

    async publishPreview() {
        await this.publishCommon(true, false, false);
    };

    async publishCommon(
        isPublishPreview: boolean,
        shouldConfirm: boolean,
        isPublishCloneWithPreviewWording: boolean
    ) {
        await publishHandler(
            this.publishUrlValue,
            this.publishPreviewUrlValue,
            this.destinationNameValue,
            this.languageValue,
            this.destinationUniqueIdValue,
            this.activationCodeValue,
            this.isExternalUserValue,
            isPublishPreview,
            this.getJobUrlValue,
            () => {
                history.back();
            },
            shouldConfirm,
            isPublishCloneWithPreviewWording
        );
    };
  
    forcePublishCheckboxClick() {
        if (this.forcePublishCheckboxTarget.checked) {
            this.publishButtonTarget.disabled = false;
        } else {
            this.publishButtonTarget.disabled = true;
        }
    }

    requestPublish() {
        const requestPublishUrlValue = this.requestPublishUrlValue;
        const getJobUrl = this.getJobUrlValue;

        bootbox.confirm({
            message: "Do you really want to ask SmartGuide content team to review the changes and publish them to the mobile app?",
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Yes),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_No),
                    className: dialogCancelButtonClassName
                }
            },
            callback: (result: boolean) => {
                if (!result) return;

                trackEvent('destinationPublishRequestLaunched', { destinationName: this.destinationNameValue });

                executeCommandWithJobCompletion(
                    requestPublishUrlValue,
                    getJobUrl,
                    null,
                    true,
                    "Your request was received - we'll contact you as soon as your changes are published to the mobile app. Thank you for your hard work!",
                    () => {
                        Turbo.clearCache();
                        history.back();
                    }
                );
            }
        });
    }
}

